/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `sensor` - sensor
 * * `alerts` - alerts
 * * `rolling_averages` - rolling_averages
 * @export
 */
export const SensorDataRequestCreateDataTypeEnum = {
    Sensor: 'sensor',
    Alerts: 'alerts',
    RollingAverages: 'rolling_averages'
} as const;
export type SensorDataRequestCreateDataTypeEnum = typeof SensorDataRequestCreateDataTypeEnum[keyof typeof SensorDataRequestCreateDataTypeEnum];


export function instanceOfSensorDataRequestCreateDataTypeEnum(value: any): boolean {
    for (const key in SensorDataRequestCreateDataTypeEnum) {
        if (Object.prototype.hasOwnProperty.call(SensorDataRequestCreateDataTypeEnum, key)) {
            if (SensorDataRequestCreateDataTypeEnum[key as keyof typeof SensorDataRequestCreateDataTypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SensorDataRequestCreateDataTypeEnumFromJSON(json: any): SensorDataRequestCreateDataTypeEnum {
    return SensorDataRequestCreateDataTypeEnumFromJSONTyped(json, false);
}

export function SensorDataRequestCreateDataTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): SensorDataRequestCreateDataTypeEnum {
    return json as SensorDataRequestCreateDataTypeEnum;
}

export function SensorDataRequestCreateDataTypeEnumToJSON(value?: SensorDataRequestCreateDataTypeEnum | null): any {
    return value as any;
}

export function SensorDataRequestCreateDataTypeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): SensorDataRequestCreateDataTypeEnum {
    return value as SensorDataRequestCreateDataTypeEnum;
}

